import { type FC, type ReactNode } from 'react';
import classnames from 'classnames';

import dibsCss from 'dibs-css';

const GetHelpZendeskTopicsGroup: FC<{ groupLabel: string; children: ReactNode }> = ({
    groupLabel,
    children,
}) => {
    return (
        <>
            <div
                className={classnames(
                    dibsCss.sassyFontBodyMediumHeavy,
                    dibsCss.textIron,
                    dibsCss.mbSmaller
                )}
            >
                {groupLabel}
            </div>
            <div
                className={classnames(
                    dibsCss.flex,
                    dibsCss.flexCol,
                    dibsCss.gapSmaller,
                    dibsCss.itemsStart,
                    dibsCss.mbMedium
                )}
            >
                {children}
            </div>
        </>
    );
};

export { GetHelpZendeskTopicsGroup };
